// @ts-check
/** Admin dashboard: one aggregate request for every block. */

import api from '../utils/apiClient';

const adminDashboardService = {
  /**
   * The server caches the summary per role and range for 60s; `fresh` makes it recompute (the Refresh button).
   * @param {'7d' | '30d'} range
   * @param {{ fresh?: boolean }} [options]
   * @returns {Promise<{ range: string, generated_at: string, blocks: Record<string, object | null>, failed: string[] }>}
   */
  getSummary: (range, { fresh = false } = {}) =>
    api.get(`/api/admin/dashboard/summary?range=${range}${fresh ? '&fresh=true' : ''}`),

  /**
   * Email the one allowed reminder for an unredeemed welcome code. Rejects on 409 (already sent) or 502 (email failed).
   * @param {string} codeId
   * @returns {Promise<{ sent: boolean }>}
   */
  sendWelcomeReminder: (codeId) => api.post(`/api/admin/dashboard/welcome-discount/${codeId}/remind`),
};

export default adminDashboardService;
